module.exports = __webpack_public_path__ + "media/icons/firma-unactive@2x-74da85ea.png";